const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "agentGroupName_contains",
      label: "Agent Group Name",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "tagsList_contains",
      label: "Tags",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    main: true,
    props: {
      filterName: "validFrom",
      label: "Valid from date between",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    main: true,
    props: {
      filterName: "validTo",
      label: "Valid to date between",
      filterValue: null,
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/plugins/circuit-discounts/list-filters.js